// extracted by extract-css-chunks-webpack-plugin
module.exports = {"facet":"facet___Fxmp8","title":"title___pprzF","titleFontWeight":"titleFontWeight___YORUH","expander":"expander___Xs31a","panel":"panel___lN8PV"};